import React, { useState } from "react";
import { Backdrop, Box, Button, CircularProgress, Link, Typography } from "@mui/material";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import currency from "currency.js";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      backgroundColor: "#fff",
      fontSmoothing: "antialiased",
      fontSize: "18px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

export default function StripePaymentElement(props) {
  const { name, phone, amount, chargePaymentMethod, validate } = props;

  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState("");

  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const arr = validate();

    if (arr.length > 0) {
      setError(arr.join(". "));
    } else {
      setProcessing(true);

      const result = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
        billing_details: {
          name,
          phone,
        },
      });

      setProcessing(false);

      if (result.error) {
        setError(result.error.message);
      } else {
        // Otherwise send paymentMethod.id to your server (see Step 4)
        try {
          await chargePaymentMethod(result.paymentMethod.id, amount);
        } catch (e) {
          setError(e.message);
          setProcessing(false);
        }
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* Show any error that happens when processing the payment */}
      {error && (
        <Box align="center" my={1}>
          <Typography color="error">{error}</Typography>
        </Box>
      )}
      <CardElement options={CARD_ELEMENT_OPTIONS} id="card-element" />
      <Button
        sx={props.sx || ""}
        size="large"
        type="submit"
        color="primary"
        variant="contained"
        fullWidth
        disabled={+amount < 0.5}
      >
        {currency(amount).format()} | CHARGE CARD
      </Button>
      {+amount < 0.5 && (
        <Box my={0.25} textAlign={"center"}>
          <Typography variant="caption" color="error">
            Charge amount should be $0.50 or more
          </Typography>
        </Box>
      )}
      {processing && (
        <Backdrop open={true} style={{ zIndex: "1000", color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </form>
  );
}
